<template>
  <div class="return-aside">
    <!-- 仓库信息 -->
    <div class="warehouse-container">
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <span v-if="warehouseCurrentPag > 1" class="pro-page" @click="proPage"></span>
      </transition>
      
      <div class="warehouse-group-container">
        <div
          class="warehouse-group"
          :class="{'warehouse-group-ative':(jIdx+1) === warehouseCurrentPag}"
          v-for="(j, jIdx) in warehouseList" 
          :key="jIdx"
        >
          <div
            class="warehouse-group-row" 
            :class="{'is-active': `${jIdx}-${idx}` === activeIndex}"
            v-for="(v, idx) in j" 
            :key="idx"
            @click="selectWarehouse(v, idx, jIdx)"
          >
            <div class="warehouse-name">
              <span :title="v.name">{{ v.name }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <span v-if="warehouseList.length > 1 && warehouseCurrentPag < warehouseList.length" class="next-page" @click="nextPage"></span>
      </transition>
    </div>

    <!-- 项目信息 -->
    <div class="project-container">
      <div class="project-search">
        <el-input
          v-model="searchProjectName"
          placeholder="请输入项目名称"
          @keyup.enter.native="searchProjectNameFnc"
        >
          <img class="search-img" slot="suffix" src="../../assets/images/search/search.png" />
        </el-input>
      </div>
      <div class="project-list">
        <div
          class="project-row"
          :class="{'project-row-active': index === projectIndex}"
          v-for="(item, index) in projectList"
          :key="index"
          @click="selectProject(item, index)"
        >
          <p class="project-name" :title="item.name">{{ item.name }}</p>
          <el-tooltip effect="dark" :disabled="item.customerName.length < 5" :content="item.customerName" placement="top">
            <div class="customer-name" style="width: 48px;">
              <span class="font10">{{ item.customerName.substr(0,4) }}</span>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import warehouseMixins from '@/common/mixins/warehouse.js'
import projectMixins from '@/common/mixins/project.js'
import { fuzzyQuery } from "common/js/util";
export default {
  mixins: [warehouseMixins, projectMixins],

  data() {
    return {
      // 当前仓库下标
      activeIndex: '0-0',
      // 当前仓库组下标
      warehouseCurrentPag: 1,
      searchProjectName: '',
      // 当前项目下标
      projectIndex: 0,
      warehouseId: null,
    }
  },

  async created() {
    await this.initAsyncWarehouse()
    this.warehouseList = this.spitArr(this.warehouseList)
    // 默认展示第一个仓库
    this.selectWarehouse(this.warehouseList[0][0],0,0)
  },

  methods: {
    spitArr(arr) {
      let newArr = [];
      /* 将一位数组分割成每2个一组 */
      for (let j = 0; j < arr.length; j += 2) {
        newArr.push(arr.slice(j, j + 2));
      }
      return newArr;
    },

    /**
     * @desc 选择仓库
     * @params row: 仓库对象; index：仓库下标; parentIndex: 当前仓库组下标;
     */
    async selectWarehouse(row, index, parentIndex) {
      this.warehouseId = row.id
      this.activeIndex = `${parentIndex}-${index}`
      this.warehouseCurrentPag = parentIndex+1
      await this.initAsyncProjectListByWarehouse(row.id)
      // 默认展示第一个项目
      this.selectProject(this.projectList[0], 0)
    },
    
    nextPage() {
      if (this.warehouseCurrentPag < this.warehouseList.length) this.warehouseCurrentPag++
    },

    proPage() {
      if (this.warehouseCurrentPag > 1) this.warehouseCurrentPag--
    },

    searchProjectNameFnc() {
      this.projectList = fuzzyQuery(this.projectListCopy, item => item.name.indexOf(this.searchProjectName) !== -1)
    },

    /**
     * @desc 选择项目
     */
    selectProject(row, index) {
      this.projectIndex = index
      let data = {
        customerId: row.customerId,
        projectId: row.id,
        warehouseId: this.warehouseId
      }
      this.$emit('selectProjectFnc', data)
    },
  }
}
</script>

<style lang='scss'>
.return-aside {
  width: 244px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-right: 1px solid $baseThreeSnow;
  /* 仓库详细 */
  .warehouse-container {
    position: relative;
    height: 48px;
    padding: 0px 18px;
    box-sizing: border-box;
    border-bottom: 1px solid $baseThreeSnow;
    .warehouse-group-container {
      width: 100%;
      height: 48px;
      overflow: hidden;
      .warehouse-group {
        height: 100%;
        display: none;
        &-row {
          width: 50%;
          height: 100%;
          @include flex-center;
          cursor: pointer;
          transition: all 0.3s;
          .warehouse-name {
            span {
              @include two-wrap-ellipsis(1);
            }
            font-size: 14px;
            font-family: 'PingFang SC-Regular, PingFang SC';
            font-weight: 400;
            color: $baseGrey;
          }
        }
        .is-active {
          transition: all 0.3s;
          .warehouse-name {
            color: $baseBlue;
            @include border-bottom(100%, 3px, $baseBlue);
            &::after {
              bottom: -17px;
              border-radius: 3px 3px 0px 0px;
            }
          }
        }
      }
      .warehouse-group-ative {
        @include flex-start;
      }
    }
    .pro-page {
      position: absolute;
      top: 50%;
      left: 2px;
      transform: translateY(-50%);
      display: inline-block;
      background: url('../../assets/images/arrow/arrow-left.png') no-repeat;
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    .next-page {
      position: absolute;
      top: 50%;
      right: 2px;
      transform: translateY(-50%);
      display: inline-block;
      background: url('../../assets/images/arrow/arrow-right.png') no-repeat;
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }

  /* 项目信息 */
  .project-container {
    flex: 1;
    height: calc(100% - 48px);
    padding: 20px 0px;
    box-sizing: border-box;
    .project-search {
      margin-bottom: 8px;
      padding: 0px 16px;
      .el-input {
        width: 100%;
        .search-img {
          width: 16px;
          height: 16px;
        }
        .el-input__prefix, .el-input__suffix {
          top: 8px;
          height: 16px;
        }
      }
    }
    .project-list {
      height: calc(100% - 40px);
      padding: 0px 8px;
      box-sizing: border-box;
      overflow-y: auto;
      @include scrollbarNotrack(4px);
      .project-row {
        height: 32px;
        padding: 0px 8px;
        border-radius: 4px;
        cursor: pointer;
        @include flex-between;
        // &:hover {
        //   background: $baseTwoLightBlue;
        //   .project-name,
        //   .customer-name {
        //     color: $baseBlue;
        //   }
        //   .customer-name {
        //     background: white;
        //   }
        // }
        .project-name {
          width: 116px;
          font-size: 14px;
          font-family: 'PingFang SC-Regular, PingFang SC';
          font-weight: 400;
          color: $baseGrey;
          @include two-wrap-ellipsis(1);
        }
        .customer-name {
          height: 16px;
          line-height: 12px;
          font-family: 'PingFang SC-Regular, PingFang SC';
          font-weight: 400;
          color: $baseTwoGrey;
          border-radius: 3px;
          background: $baseSixSnow;
          text-align: center;
          span {
            display: inline-block;
            transform-origin: inherit;
          }
        }
      }
      .project-row-active {
        background: $baseTwoLightBlue;
        .project-name,
        .customer-name {
          color: $baseBlue;
        }
        .customer-name {
          background: white;
        }
      }
    }
  }
}
</style>
